import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState, useRef } from 'react';

/**
 * A hook for components that need to know when a ref changes.
 *
 * Returns a tuple like `[ref, setRef]`, where `ref` is a ref object,
 * and `setRef` is a ref callback. Whenever the ref callback is called,
 * the ref object is updated with the value passed to the callback, and the
 * component is rerendered.
 */
function useRefCallback(
/**
 * An optional initial value for the ref.
 * Used like `React.useRef(initialValue)`.
 */
initialValue,
/**
 * An optional ref object or callback ref.
 * Useful when the component needs to handle ref forwarding.
 */
innerRef) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    f = _useState2[1];
  var forceUpdate = useCallback(function () {
    return f(function (v) {
      return !v;
    });
  }, []);
  var ref = useRef(initialValue);
  var callback = useCallback(function (node) {
    if (typeof innerRef === 'function') {
      innerRef(node);
    } else if (innerRef && 'current' in innerRef) {
      innerRef.current = node;
    }
    if (ref.current !== node) {
      ref.current = node;
      forceUpdate();
    }
  }, [innerRef, forceUpdate]);
  return [ref, callback];
}
export default useRefCallback;